/**
 * Created by Alex Aguilar on 3/24/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('stretchCtrl', stretchCtrl)
        .controller('newStretchCtrl', newStretchCtrl)
        .controller('editStretchCtrl', editStretchCtrl)
        .controller('viewDetailStretchCtrl', viewDetailStretchCtrl);

    stretchCtrl.$inject = ['stretchService', 'dialogs','stretches'];
    newStretchCtrl.$inject = ['stretchService','stretchAssistants','stretches'];
    editStretchCtrl.$inject = ['stretchService','stretch','stretchAssistants'];
    viewDetailStretchCtrl.$inject = ['$rootScope', '$scope','$stateParams','stretchService'];

    function stretchCtrl(stretchService, dialogs,stretches) {
        var vm = this;
        vm.stretches = stretches.data.stretches;

        vm.deleteStretch = function(index, originId, destinyId){

            var dlg = dialogs.confirm();

            dlg.result.then(function(btn){
                stretchService.deleteStretch(originId, destinyId)
                    .then(function(){
                        vm.stretches.splice(index, 1);
                    });
            },function(btn){});
        }

    }

    function newStretchCtrl(stretchService, stretchAssistants,stretches) {
        var vm = this;

        vm.stretchAssistantsAux = stretchAssistants.data.stretchAssistants;
        vm.stretches = stretches.data.stretches;
        vm.stretchAssistants = [];
        vm.disableSelects = false;
        vm.stretchAssistant = {};
        vm.action = "new";

        getNotThereStretches(vm.stretchAssistantsAux, vm.stretches);

        function getNotThereStretches(stretchAssistantsAux, stretches){
            var stretchesAux = [];
            if(stretchAssistantsAux.length > 0){
                for(var i = 0; i < stretchAssistantsAux.length; i++){
                    var stretchAssistantAux = stretchAssistantsAux[i];
                    var thereObject = thereObjectArray(stretchAssistantAux, stretches);
                    if(thereObject == false){
                        stretchesAux.push(stretchAssistantAux);
                    }
                }
                vm.stretchAssistants = stretchesAux;
            }else{
                vm.stretchAssisvm= vm.stretchAssistantsAux;
            }
        }

        function thereObjectArray(objectJson, arrayJson){
            var res = false;
            for(var i = 0; i < arrayJson.length; i++){
                var elemJson = arrayJson[i];
                var id = (elemJson.originAirport.rId).toString() + (elemJson.destinyAirport.rId).toString();
                var id2 = (objectJson.originAirport.rId).toString() + (objectJson.destinyAirport.rId).toString();
                if(id == id2){
                    res = true;
                    break;
                }
            }
            return res;
        }

        vm.saveStretch = function(isValid, stretchAux){
            if(isValid){
                var originAirport= vm.stretchAssistant.selected.originAirport;
                var destinyAirport= vm.stretchAssistant.selected.destinyAirport;

                var originName = "",
                    destinyName = "";

                if(originAirport.iataCode != ""){
                    originName = originAirport.iataCode;
                }

                if(destinyAirport.iataCode != ""){
                    destinyName = destinyAirport.iataCode;
                }

                vm.stretch = {
                    "originAirport": {
                        "rId": originAirport.rId
                        /*"locality": {
                            "rId": originAirport.locality.rId,
                            "region": {
                                "rId": originAirport.locality.region.rId,
                                "country": {
                                    "rId": originAirport.locality.region.country.rId
                                }
                            }
                        }*/
                    },
                    "destinyAirport": {
                        "rId": destinyAirport.rId
                        /*"locality": {
                            "rId": destinyAirport.locality.rId,
                            "region": {
                                "rId": destinyAirport.locality.region.rId,
                                "country": {
                                    "rId": destinyAirport.locality.region.country.rId
                                }
                            }
                        }*/
                    },
                    "name": originAirport.iataCode
                    + " - " + destinyAirport.iataCode,
                    "initials": originName + " - " + destinyName,
                    "distance": stretchAux.distance
                };

                stretchService.saveStretch(vm.stretch);
            }
        }
    }

    function editStretchCtrl(stretchService,stretch,stretchAssistants) {
        var vm = this;

        vm.disableSelects = true;
        vm.action = "update";
        vm.stretch = stretch.data;
        vm.stretchAssistant = {
            "originAirport": stretch.data.originAirport,
            "destinyAirport": stretch.data.destinyAirport
        };
        vm.stretchAssistants = stretchAssistants.data.stretchAssistants;

        vm.saveStretch = function(isValid, stretch){
            if(isValid){
                stretchService.updateStretch(stretch);
            }
        }
    }

    function viewDetailStretchCtrl($rootScope, $scope,$stateParams,stretchService) {

        $scope.stretchAssistants = [];
        $scope.disableSelects = true;
        $scope.stretch = {};
        $scope.action = "update";

        getStretch($stateParams.originId, $stateParams.destinyId);

        function getStretch(originId, destinyId){
            $rootScope.overlayLoading = false;
            stretchService.getStretch(originId, destinyId)
                .then(function(res){
                    $rootScope.overlayLoading = true;
                    $scope.stretch = res.data;
                }, function(){
                    $rootScope.overlayLoading = true;
                });
        }
    }
})();
